/* eslint-disable react/prop-types */
import React, { createContext, useState } from 'react';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const handleChangeLoading = (stateLoading) => {
    setLoading(stateLoading);
  };

  const data = { loading, handleChangeLoading };
  return <LoaderContext.Provider value={data}>{children}</LoaderContext.Provider>;
};

export default LoaderContext;
